<template>
  <div class="overflow-hidden bg-white">
    <div class="flex items-center justify-between border-b p-4">
      <div class="w-50" v-for="item in headerFields" :key="item.key">
        <span class="text-xs font-medium text-label">{{ item.label }}</span>
      </div>
    </div>
    <div v-for="tax in dataInfo" :key="tax.id">
      <div
        @click="openSection(tax.id)"
        class="flex cursor-pointer justify-between border-b p-4"
      >
        <div class="w-50" v-for="(item, index) in headerFields" :key="item.key">
          <div class="m-0 flex items-center text-sm text-headline">
            <dropdown-chevron
              v-if="index === 0 && hasToggleBox"
              :is-open="tax['isActive']"
            />
            <slot
              :name="`cell(${item.key})`"
              :value="getTaxData(tax, item.key)"
              :item="tax"
            >
              {{ getTaxData(tax, item.key) ?? "-" }}
            </slot>
          </div>
        </div>
      </div>
      <div
        class="bg-disabled p-5 px-4"
        v-if="getTaxData(tax, parameterOpenToggle) && tax.isActive"
      >
        <div class="bg-white p-4">
          <div class="flex items-center justify-between border-b p-4">
            <div class="w-50" v-for="item in toggleField" :key="item.key">
              <span class="text-xs font-medium text-label">
                {{ item.label }}
              </span>
            </div>
          </div>
          <div
            v-for="cmp in getTaxData(tax, parameterOpenToggle)"
            :key="cmp.name"
          >
            <div class="flex justify-between border-b p-4">
              <div class="w-50" v-for="item in toggleField" :key="item.key">
                <p class="m-0 text-sm text-headline">
                  <slot
                    :name="`box(${item.key})`"
                    :value="cmp[item.key]"
                    :item="cmp"
                  >
                    {{ cmp[item.key] ?? "-" }}
                  </slot>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";

import get from "lodash/get";

import type { SectionBody, TableField } from "@/models/commercialData/Codat";
import type { PropType } from "vue";

const props = defineProps({
  data: {
    type: Array as PropType<SectionBody[]>,
    required: true,
  },
  headerFields: {
    type: Array as PropType<{ key: string; label: string }[]>,
    required: true,
  },
  hasToggleBox: {
    type: Boolean,
  },
  parameterOpenToggle: {
    type: String,
  },
  toggleField: {
    type: Array as PropType<TableField[]>,
  },
});

const dataInfo = ref(props.data);

const openSection = (id: string | number) => {
  const section = dataInfo.value.find((item) => item.id === id);
  if (section) {
    section.isActive = !section.isActive;
  }
};

const getTaxData = (
  tax: SectionBody,
  key: string | undefined
): { name: string; [k: string]: string }[] | null => {
  if (!key) {
    return null;
  }
  return get(tax, key, null);
};
</script>
